import { TslDebug } from '@/components/TslDebug';
import TslDebugArea from '@/components/TslDebugArea';
import WebGpuCanvas from '@/components/WebGpuCanvas';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import * as React from 'react';
import { positionLocal, length, Fn, sin, time, abs, step } from 'three/tsl';

export type Props = {};

function App04(props: Props) {
  const {} = props;
  const main = React.useMemo(() => {
    const ret = Fn(() => {
      const p = positionLocal.toVar();
      p.mulAssign(5);
      p.assign(p.fract().step(0.5));
      p.assign(length(p));
      p.assign(sin(p.mul(10).add(time)));
      p.assign(abs(p));
      p.assign(step(0.5, p));
      return p;
    });
    return ret();
  }, []);
  return (
    <TslDebugArea>
      {(el) => (
        <WebGpuCanvas>
          <PerspectiveCamera
            makeDefault
            fov={53}
            aspect={el.clientWidth / el.clientHeight}
            near={0.1}
            far={10}
            position={[0, 0, 1]}
          />
          <mesh name="node-mesh">
            {/* <boxGeometry args={[1, 1, 1]} /> */}
            <planeGeometry args={[2, 1]} />
            <nodeMaterial fragmentNode={main} />
            <TslDebug meshName={'node-mesh'} />
          </mesh>
          <axesHelper />
          <OrbitControls />
        </WebGpuCanvas>
      )}
    </TslDebugArea>
  );
}

export default React.memo(App04);
